<div class="toaster-container" *ngIf="showHeaderFooter"><app-toaster></app-toaster></div>
<app-header [user]="user" *ngIf="showHeaderFooter; else loginScreen">
  <section class="page-container">
    <ng-content></ng-content>
  </section>
</app-header>

<!-- else for showing login page -->
<ng-template #loginScreen>
  <router-outlet></router-outlet>
</ng-template>

<motif-progress-loader
  [show]="showLoader"
  [fullScreen]="true"
></motif-progress-loader>
